import { compileString } from 'sass';
import { API_URL, Result_Per_Page, API_KEY } from './config.js';
import { getJSON, sendJSON } from './helper.js';

export const state = {
  recipe: {},
  search: {
    query: '',
    results: [],
    page: 1,
    resultperpage: Result_Per_Page,
  },
  bookmarks: [],
};

const createRecipeObject = function (data) {
  const { recipe } = data.data;
  return {
    id: recipe.id,
    title: recipe.title,
    publisher: recipe.publisher,
    sourceUrl: recipe.source_url,
    image: recipe.image_url,
    servings: recipe.servings,
    cookingTime: recipe.cooking_time,
    ingredients: recipe.ingredients,
    ...(recipe.key && { key: recipe.key }),
  };
};

export const loadRecipe = async function (id) {
  try {
    const data = await getJSON(`${API_URL}/${id}?key=${API_KEY}`);
    // console.log(data);
    state.recipe = createRecipeObject(data);

    if (state.bookmarks.some(bookmark => bookmark.id === id))
      state.recipe.bookmark = true;
    else state.recipe.bookmark = false;
  } catch (err) {
    throw err;
  }
};

export const loadSearch = async function (query) {
  try {
    state.search.query = query;
    const data = await getJSON(`${API_URL}?search=${query}&key=${API_KEY}`);
    // console.log(data);
    state.search.results = data.data.recipes.map(el => {
      return {
        id: el.id,
        title: el.title,
        publisher: el.publisher,
        imageUrl: el.image_url,
        ...(el.key && { key: el.key }),
      };
    });
    state.search.page = 1;
  } catch (err) {
    console.log(err.message);
  }
};

export const getSaerchResultPage = function (page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultperpage;
  const end = page * state.search.resultperpage;
  return state.search.results.slice(start, end);
};

export const updateServing = function (newServing) {
  state.recipe.ingredients.forEach(element => {
    // console.log(element);
    element.quantity = element.quantity * (newServing / state.recipe.servings);
    // console.log(element);
  });
  state.recipe.servings = newServing;
};

export const addBookmark = function (recipe) {
  state.bookmarks.push(recipe);
  if (recipe.id === state.recipe.id) state.recipe.bookmark = true;
  loaclStorageBookmark();
};

export const removeBookmark = function (id) {
  const index = state.bookmarks.findIndex(el => el.id === id);
  state.bookmarks.splice(index, 1);
  if (id === state.recipe.id) state.recipe.bookmark = false;
  loaclStorageBookmark();
};

const loaclStorageBookmark = function () {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
};

export const uploadDataCall = async function (data) {
  // console.log(data);
  try {
    const ingredients = Object.entries(data)
      .filter(
        element => element[0].startsWith('ingredient') && element[1] != ''
      )
      .map(ing => {
        const ingArr = ing[1].replaceAll(' ', '').split(',');
        if (ingArr.length !== 3) throw new Error('Wrong ingredient format!');

        const [quantity, unit, description] = ingArr;
        return { quantity: quantity ? +quantity : null, unit, description };
      });

    recipe = {
      title: data.title,
      publisher: data.publisher,
      cooking_time: +data.cookingTime,
      source_url: data.sourceUrl,
      servings: +data.servings,
      image_url: data.image,
      ingredients,
    };
    // console.log(recipe);

    const backData = await sendJSON(`${API_URL}?key=${API_KEY}`, recipe);
    // console.log(backData.data.recipe);
    state.recipe = createRecipeObject(backData);
    // console.log(state.recipe);
    addBookmark(state.recipe);
  } catch (err) {
    throw err;
  }
};

const init = function () {
  const data = localStorage.getItem('bookmarks');
  if (data) state.bookmarks = JSON.parse(data);
};

init();
